import React, { Component } from 'react';
import GeofenceCalculationItemCard from './geofence-calculation-item-card';
import Money from 'src/common/entity/basic-types/Money';
import BigNumber from 'bignumber.js';
import { Currency, Entities, TOMCAT_URL } from 'src/common';

class GeofenceCalculationItems extends Component {
    constructor(props) {
        super(props);
        this.state = {
            searchQuery: '',
        };
    }

    handleSearchChange = event => {
        this.setState({ searchQuery: event.target.value });
    };

    handleItemClick = (id, item) => {
        this.props.setActiveGeofenceBoundary(item.geofenceBoundaries.boundaryList);
    };

    render() {
        const { geofenceCalculations, geofenceAreas, t } = this.props;
        const { searchQuery } = this.state;

        const geofenceCalculationsMap = geofenceCalculations.reduce(function (map, item) {
            map[item.geofenceArea.id] = item;
            return map;
        }, {});

        const mergedItems = geofenceAreas.map(item => {
            if (geofenceCalculationsMap[item.id]) {
                return {
                    ...geofenceCalculationsMap[item.id],
                    geofenceBoundaries: geofenceCalculationsMap[item.id].geofenceArea,
                    company: `${TOMCAT_URL}api/${Entities.BUS_COMPANY.repository}/${this.props.busCompany.entity.id}`,
                    geofenceArea: `${TOMCAT_URL}api/${Entities.GEOFENCE_AREA.repository}/${item.id}`,
                    countryCalculation: `${TOMCAT_URL}api/${Entities.COUNTRY_CALCULATION.repository}/${this.props.countryCalculation.id}`,
                };
            } else {
                return {
                    id: null,
                    active: false,
                    name: item.name,
                    surcharge: new Money(new BigNumber(0), Currency.EUR),
                    geofenceBoundaries: item,
                    company: `${TOMCAT_URL}api/${Entities.BUS_COMPANY.repository}/${this.props.busCompany.entity.id}`,
                    geofenceArea: `${TOMCAT_URL}api/${Entities.GEOFENCE_AREA.repository}/${item.id}`,
                    countryCalculation: `${TOMCAT_URL}api/${Entities.COUNTRY_CALCULATION.repository}/${this.props.countryCalculation.id}`,
                };
            }
        });

        const filteredItems = mergedItems.filter(
            item => item.name && item.name.toLowerCase().includes(searchQuery.toLowerCase()),
        );

        return (
            <div style={styles.container}>
                <div style={styles.searchWrapper}>
                    <input
                        type="text"
                        placeholder={t('geofence.form.search') + '...'}
                        value={searchQuery}
                        onChange={this.handleSearchChange}
                        style={styles.searchInput}
                    />
                </div>

                {filteredItems.length === 0 ? (
                    <div style={{ padding: '15px', color: '#666' }}>{t('geofence.response.not_found')}</div>
                ) : (
                    <div style={styles.gridContainer}>
                        {filteredItems.map((item, index) => {
                            const itemId = item.id !== null && item.id !== undefined ? item.id : `fallback-${index}`;
                            return (
                                <GeofenceCalculationItemCard
                                    key={itemId}
                                    itemId={itemId}
                                    item={item}
                                    t={this.props.t}
                                    busCompany={this.props.busCompany}
                                    onItemClick={this.handleItemClick}
                                />
                            );
                        })}
                    </div>
                )}
            </div>
        );
    }
}

const styles = {
    container: {
        width: '100%',
    },
    searchWrapper: {
        padding: '10px',
        width: '100%',
        boxSizing: 'border-box',
    },
    searchInput: {
        width: '100%',
        padding: '8px 12px',
        fontSize: '14px',
        border: '1px solid #ccc',
        borderRadius: '4px',
        boxSizing: 'border-box',
        outline: 'none',
    },
    gridContainer: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(calc(33% - 15px), 1fr))',
        gap: '15px',
        width: '100%',
        padding: '10px',
        boxSizing: 'border-box',
        maxHeight: '400px',
        overflowY: 'scroll',
    },
};

export default GeofenceCalculationItems;
